export {default as ReadableFileSize} from './file-size-view';
